import React from "react";
import { Asset, getAsset } from "../../../util/util";
import Button from "../buttons/Button";
import "./AddinValueSlideshow.css";

interface IAddinValueSlideProps {
  title: string,
  text?: string,
  asset: Asset
}

const assets: Array<IAddinValueSlideProps> = [
  {
    title: "Welcome to MFA!",
    text: "We're thrilled that you've downloaded our powerful underwriting add-in designed specifically for multifamily investors and analysts.",
    asset: Asset.ValueStart
  },
  {
    title: "Analyze today!",
    text: "With the MFA add-in, you'll have instant access to the most up-to-date underwriting files that are available for download from inside the add-in.",
    asset: Asset.ValueAnalysis
  },
  {
    title: "Powerful Tools!",
    text: "Create a free account to get access to our free underwriting tools including a robust underwriting model and tools for market analysis.",
    asset: Asset.ValueTools
  },
  {
    title: "Useful Links!",
    text: "Gain detailed insights into the market with our hand-picked collection of helpful third party links directly at your fingertips.",
    asset: Asset.ValueLinks
  },
  {
    title: "Save time!",
    text: "We've spent thousands of hours developing our models and services. Benefit from our experience and save time and money.",
    asset: Asset.ValueTime
  },
  {
    title: "A Smart Choice!",
    text: "Our add-in is an invaluable tool for multifamily investors looking to streamline their underwriting process and make informed investment decisions.",
    asset: Asset.ValueValuation
  },
  {
    title: "Sign up today!",
    text: "Create your free account on our website today. To do this, just click the button below to join. You will get instant access to all the latest features.",
    asset: Asset.ValueEnd
  }
]

export default function AddinValueSlideshow() {

  const [asset, setAsset] = React.useState<number>(0);

  const assetCount = assets.length;
  const usedAsset = assets[asset];

  if (!usedAsset) return null;

  return (
    <div className="w-100 mt-sm-5 mt-4 d-flex flex-column align-items-center text-center gap-3" >
      <div className="d-flex addin-value-slide flex-column align-items-center flex-sm-row w-100 h-100 justify-content-sm-between align-items-sm-center gap-sm-5 gap-1" style={{ userSelect: "none" }} >
        <div className="d-flex flex-column w-100 align-items-center">
          {
            usedAsset.title && <h1 className="font-code display-4 text-uppercase">{usedAsset.title}</h1>
          }
          {
            usedAsset.text && <p>{usedAsset.text}</p>
          }
        </div>
        <div
          className="d-flex"
          style={{ flexShrink: 0, height: "min(30vmin, 400px)", width: "min(30vmin, 400px)" }}
        >
          <img
            className="value-slide-img"
            src={getAsset(usedAsset.asset)}
            style={{
              width: "100%",
              objectFit: "cover",
              height: "100%",
              userSelect: "none",
            }}
          />
        </div>
      </div>
      <div className="w-100 d-flex flex-row align-items-center justify-content-between" style={{ minHeight: "50px" }}>
        {
          asset !== 0 && (
            <Button
              text="Back"
              icon="arrow-left"
              onClick={async () => setAsset(asset - 1)}
            />
          )
        }
        <Button
          icon="arrow-right"
          iconPosition="end"
          color="var(--teal-600)"
          variant="subtle"
          text="Next Win"
          className="ms-auto"
          onClick={async () => setAsset(asset + 1)}
          disabled={asset >= (assetCount - 1)}
        />
      </div>
    </div>
  )
}